import { Form, FormikProvider, useFormik } from 'formik';
import { useSearchParams } from 'react-router-dom';

import { Button, FormikInputPassword } from '@febos-io/design';
import { utils } from '@febos-io/common';

import { useMemo, useState } from 'react';
import useTranslation from '../hooks/useTranslation';
import PasswordRequirements from './PasswordRequirements';
import { useResetPasswordUpdate } from '../hooks';

export function ResetPasswordForm() {
  const [enabledButton, setEnabledButton] = useState(false);
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const code = useMemo(() => {
    return searchParams.get('passwordCode');
  }, [searchParams]);

  const { loading, onSubmit } = useResetPasswordUpdate();

  const formik = useFormik({
    initialValues: {
      code: code,
      password: '',
      newPassword: ''
    },
    validationSchema: utils.validator.object().shape({
      password: utils.validator.string().required('This field is required'),
      newPassword: utils.validator
        .string()
        .required('This field is required')
        .passwordMatch('The passwords do not match')
    }),
    onSubmit: onSubmit
  });
  return (
    <FormikProvider value={formik}>
      <Form className="auth-login-form mt-2">
        <FormikInputPassword
          name="password"
          label={t('New Password')}
          type="password"
          icon="lock"
          className="mb-1"
        />
        <FormikInputPassword
          name="newPassword"
          label={t('Confirm Password')}
          type="password"
          icon="lock"
          className="mb-1"
        />
        <PasswordRequirements
          password={formik.values.password}
          setEnabledButton={setEnabledButton}
        />
        <div className="d-grid">
          <Button type="submit" loading={loading} disabled={enabledButton}>
            {t('Create Password')}
          </Button>
        </div>
      </Form>
    </FormikProvider>
  );
}

export default ResetPasswordForm;
